export default __webpack_public_path__ + "static/media/4-como-funciona.1f63d56b.png";